module.exports = __webpack_public_path__ + "img/old-claim.5377ef2f.svg";